import styled from 'styled-components'

export const AppGuideContainer = styled.div`
  border-radius: 10px;
  overflow: hidden;
`
